import { useContext, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { AuthContext } from "./Auth";

export const ProtectedRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (localStorage.getItem("vkey") === null && !isLoggedIn) {
      localStorage.removeItem('vkey');
      navigate("/", { replace: true });
    }
  }, [isLoggedIn]);
  return <Outlet />;
};
